export const events = {
  'GTM': {
    'logIn': {
      'eventCategory': 'login',
      'eventAction': 'email_login',
      'eventLabel': 'login_page',
    },
    'signUp': {
      'eventCategory': 'signup',
      'eventAction': 'email_signup',
      'eventLabel': 'signup_page',
    },
    'logInFacebook': {
      'eventCategory': 'login',
      'eventAction': 'facebook_login',
      'eventLabel': 'login_page'
    },
    'signUpFacebook': {
      'eventCategory': 'signup',
      'eventAction': 'facebook_signup',
      'eventLabel': 'signup_page'
    },
    'logInApple': {
      'eventCategory': 'login',
      'eventAction': 'apple_login',
      'eventLabel': 'login_page'
    },
    'signUpApple': {
      'eventCategory': 'signup',
      'eventAction': 'apple_signup',
      'eventLabel': 'signup_page'
    },
    'logInGoogle': {
      'eventCategory': 'login',
      'eventAction': 'google_login',
      'eventLabel': 'login_page'
    },
    'signUpGoogle': {
      'eventCategory': 'signup',
      'eventAction': 'google_signup',
      'eventLabel': 'signup_page'
    }
  }
};